import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import conciergeApiClient from 'Services/Apis/Concierge/conciergeApiClient';

export const validateBarCodeThunk = createAsyncThunk(
    `ValidateBarCodeSlicer/validateBarCodeThunk`,
    async ({ barCode, serviceId }, { getState, rejectWithValue }) => {        
        const { user } = getState().oidc;

        const participantId = user.profile['custom:participant_id'];

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: participantId,
            username: user.profile.username || user.profile['custom:login'],
        };

        try {
            const { data } = await conciergeApiClient.get(
                `BillPayment/ValidateBarcode?serviceId=${serviceId}&barCode=${barCode}`,
                {
                    headers,
                });
    
            return data;
        } catch (err) {
            if (err.response) return rejectWithValue(err.response);
        }
    }
);

const initialState = {
    dataValidateBarCode: undefined,
    loadingValidateBarCode: false,
    errorValidateBarCode: false,
};

const ValidateBarCodeSlicer = createSlice({
    name: 'ValidateBarCode',
    initialState,
    reducers: {
        resetDataValidateBarCode: (state) => {
            state.dataValidateBarCode = undefined;
            state.loadingValidateBarCode = false;
            state.errorValidateBarCode = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(validateBarCodeThunk.pending, (state) => {
            state.dataValidateBarCode = undefined;
            state.loadingValidateBarCode = true;
            state.errorValidateBarCode = false;
        });
        builder.addCase(validateBarCodeThunk.fulfilled, (state, action) => {
            state.dataValidateBarCode = action.payload;
            state.loadingValidateBarCode = false;
            state.errorValidateBarCode = false;
        });
        builder.addCase(validateBarCodeThunk.rejected, (state, action) => {
            const { payload } = action;

            state.dataValidateBarCode = undefined;
            state.loadingValidateBarCode = false;
            state.errorValidateBarCode = payload.data.message;
        });
    },
});

export const { resetDataValidateBarCode } = ValidateBarCodeSlicer.actions;
export default ValidateBarCodeSlicer.reducer;